import React from 'react';

export const IconJustinHome = () => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00001 0.899994V4.09999M9.00001 0.899994C4.58161 0.899994 1.00001 4.48159 1.00001 8.89999C0.997285 10.6316 1.55898 12.317 2.60001 13.7008H6.20001M9.00001 0.899994C13.4184 0.899994 17 4.48159 17 8.89999C17 10.7016 16.4048 12.364 15.4 13.7008L11.8 13.7M2.60001 4.09999L4.60001 6.09999M13.4 6.09999L15.4 4.09999M1.80001 11.3H4.20001M13.8 11.3H16.2"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 11.3L9.8 6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.99997 16.1C9.63649 16.1 10.2469 15.8471 10.697 15.3971C11.1471 14.947 11.4 14.3365 11.4 13.7C11.4 13.0635 11.1471 12.453 10.697 12.0029C10.2469 11.5529 9.63649 11.3 8.99997 11.3C8.36345 11.3 7.75301 11.5529 7.30292 12.0029C6.85283 12.453 6.59998 13.0635 6.59998 13.7C6.59998 14.3365 6.85283 14.947 7.30292 15.3971C7.75301 15.8471 8.36345 16.1 8.99997 16.1Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
